import React, { useContext, useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Collapse,
  IconButton,
  Button,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EditSign from "../../../assets/componentAssets/EditSign.png";
import styles from "./CustomTable.module.css";
import Skeleton from "@mui/material/Skeleton";
import invoiceD from "../../../assets/componentAssets/invoiceD.svg";
import invoiceA from "../../../assets/componentAssets/invoiceA.png";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CustomPopUp from "../../CustomPopUp/CustomPopUp";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import { consumptionEngText, consumptionGermText } from "../../Pannel/Pannel";
const CustomTable = ({
  tableHeads = [],
  tableBodys,
  edit,
  onHandleEdit = () => {},
  handleImageClick = () => {},
  onSelectionChange,
  loading,
  onHandleView = () => {},
  HandleInvoice = () => {},
  ...otherProps
}) => {
  const { state, setState } = useContext(AppContext);
  const { stepLanguage, language } = state;
  const [tableData, setTableData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [openRows, setOpenRows] = useState({});

  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState(null);
  const HandlePopUp = (amount) => {
    setTab(amount);
    setOpen(true);
  };
  useEffect(() => {
    setTableData([]);
    if (tableBodys && tableBodys.length > 0) {
      setTableData(tableBodys);
    }
  }, [tableBodys]);
  const handleToggle = (index) => {
    setOpenRows((prev) => ({ ...prev, [index]: !prev[index] }));
  };
  const renderCellContent = (item, displayData, row) => {
    if (item.id === "status") {
      if (row.status === "Eingereicht") {
        return <p className={styles.submmited}>{displayData}</p>;
      } else if (row.status === "Nicht eingereicht") {
        return <p className={styles.notSubmmited}>{displayData}</p>;
      } else if (row.status === "Entwurf") {
        return <p className={styles.draft}>{displayData}</p>;
      }
    } else if (item.id === "certificate_status") {
      if (row.certificate_status === "Entwurf") {
        return <p className={styles.draft}>{displayData}</p>;
      } else if (row.certificate_status === "Ausgestellt") {
        return <p className={styles.issued}>{displayData}</p>;
      } else if (row.certificate_status === "Berichtigung anhängig") {
        return <p className={styles.pending}>{displayData}</p>;
      } else if (row.certificate_status === "Ausgegebene Version 2") {
        return <p className={styles.issue2}>{displayData}</p>;
      }
    } else if (item.id === "payment_status") {
      if (row.payment_status == "Ausstehend") {
        return <p className={styles.statusPending}>{displayData}</p>;
      } else if (row.payment_status == "Unbezahlt") {
        return <p className={styles.statusFailed}>{displayData}</p>;
      } else if (row.payment_status == "Bezahlt") {
        return <p className={styles.statusPaid}> {displayData}</p>;
      } else if (row.payment_status == "Keine Zahlung erforderlich") {
        return <p className={styles.statusNoRequired}> {displayData}</p>;
      }
    }
    return displayData;
  };

  return (
    <>
      <TableContainer
        component={Paper}
        {...otherProps}
        style={{ overflow: "auto" }}
      >
        <Table aria-label="simple table">
          <TableHead style={{ background: "#FBFBFB" }}>
            <TableRow>
              <TableCell padding="edit" className={styles.dateTime}>
                {" "}
                <div> {language == "de" ? "Zertifikat" : "Certificate"}</div>
              </TableCell>
              {tableHeads.map((head, index) => (
                <>
                  <TableCell
                    key={index}
                    style={{
                      fontSize: " 14px",
                      fontWeight: " 600",
                      color: "#00000080",
                      backgroundColor: "#FBFBFB",
                      minWidth: head?.minWidth,
                      textAlign: "center",
                    }}
                  >
                    <div>{head.label}</div>
                  </TableCell>
                </>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading
              ? Array(10)
                  .fill(0)
                  .map((_, rowIndex) => (
                    <TableRow key={rowIndex}>
                      <TableCell
                        padding="edit"
                        sx={{ cursor: "pointer", textAlign: "center" }}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      {tableHeads.map((_, index) => (
                        <TableCell key={index}>
                          <Skeleton animation="wave" />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
              : tableData.length > 0 &&
                tableData.map((row, rowIndex) => (
                  <React.Fragment key={rowIndex}>
                    <TableRow key={rowIndex}>
                      <TableCell
                        padding="edit"
                        sx={{ cursor: "pointer", textAlign: "center" }}
                        onClick={() => {
                          if (row.power_consumption.hasOwnProperty("id")) {
                            if (row.power_consumption.file !== null) {
                              window
                                .open(row?.power_consumption?.file, "_blank")
                                .focus();
                            }
                          }
                        }}
                      >
                        <img src={EditSign} alt="edit" />
                      </TableCell>

                      {tableHeads.map((item, index) => {
                        if (item.id === "invoice") {
                          return (
                            <>
                              {row?.invoice !== null ? (
                                <TableCell
                                  key={index}
                                  onClick={() => HandleInvoice(row)}
                                  style={{
                                    textAlign: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img src={invoiceD} alt="invoice" />
                                </TableCell>
                              ) : (
                                <TableCell
                                  key={index}
                                  onClick={() => HandleInvoice(row)}
                                  style={{
                                    textAlign: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <img src={invoiceA} alt="invoice" />
                                </TableCell>
                              )}
                            </>
                          );
                        }
                        if (item?.id == "collapse") {
                          return (
                            <TableCell>
                              <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => handleToggle(rowIndex)}
                              >
                                {openRows[rowIndex] ? (
                                  <KeyboardArrowUpIcon />
                                ) : (
                                  <KeyboardArrowDownIcon />
                                )}
                              </IconButton>
                            </TableCell>
                          );
                        }
                        const displayData = !item.key
                          ? row[item?.id]
                          : row[item?.keyName][item?.id];

                        return (
                          <TableCell
                            key={index}
                            onClick={() => onHandleView(row)}
                            style={{
                              fontWeight: "400",
                              fontSize: "14px",
                              color: "#000000CC",
                              textAlign: "center",
                            }}
                          >
                            <div>
                              {renderCellContent(item, displayData, row)}
                            </div>
                          </TableCell>
                        );
                      })}
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                        colSpan={tableHeads.length + 1}
                      >
                        <Collapse
                          in={openRows[rowIndex]}
                          timeout="auto"
                          unmountOnExit
                        >
                          <div style={{ margin: "10px" }}>
                            <Table size="small" aria-label="details">
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    style={{
                                      fontSize: " 14px",
                                      fontWeight: " 600",
                                      color: "#00000080",
                                      backgroundColor: "#FBFBFB",
                                      // width: "30%",
                                      textAlign: "center",
                                    }}
                                  >
                                    {language == "de"
                                      ? "Zusätzliche Dienstleistungen"
                                      : "Add On Service"}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      fontSize: " 14px",
                                      fontWeight: " 600",
                                      color: "#00000080",
                                      backgroundColor: "#FBFBFB",
                                      // width: "30%",

                                      textAlign: "start",
                                    }}
                                  >
                                    {language == "de" ? "Entgelte" : "Charges"}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      fontSize: " 14px",
                                      fontWeight: " 600",
                                      color: "#00000080",
                                      backgroundColor: "#FBFBFB",
                                      // width: "30%",

                                      textAlign: "start",
                                    }}
                                  >
                                    {language == "de" ? "Aktion" : "Action"}
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              {row?.add_on_services?.length > 0 && (
                                <TableBody>
                                  {row?.add_on_services?.map((item, index) => {
                                    const service = item.service;
                                    return (
                                      <TableRow key={index}>
                                        <TableCell
                                          sx={{
                                            width: "30%",
                                            fontSize: "14px",
                                            fontWeight: "400",
                                            // textAlign: "center",
                                          }}
                                        >
                                          {language == "de"
                                            ? service.german_description
                                            : service?.title}
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            width: "20%",
                                            fontSize: "14px",
                                            fontWeight: "400",
                                            // textAlign: "center",
                                          }}
                                        >
                                          {service.amount} €
                                        </TableCell>

                                        <TableCell>
                                          {service?.amount == 19 ? (
                                            <Button
                                              onClick={() =>
                                                HandlePopUp(service.amount)
                                              }
                                              variant="contained"
                                              sx={{
                                                background:
                                                  "linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",

                                                color: "white",
                                              }}
                                            >
                                              {language == "de"
                                                ? consumptionGermText?.tracking_no
                                                : consumptionEngText?.tracking_no}
                                            </Button>
                                          ) : (
                                            "-"
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              )}
                              {open && tab == 19 && (
                                <CustomPopUp
                                  open={open}
                                  handleClose={() => setOpen(false)}
                                  data={row}
                                />
                              )}
                            </Table>
                          </div>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default CustomTable;
const buttons = [
  { name: "Tracking No" },
  { name: "Appointment" },
  { name: "Appointment" },

  { name: "Appointment" },

  { name: "Appointment" },

  { name: "Appointment" },

  { name: "Appointment" },
];
